<div class="flex flex-col gap-8 w-full">

	<!-- Header -->
	<div class="flex flex-col gap-4 bg-card w-full p-6 shadow">

		<div class="flex gap-4 items-center">
			<a [routerLink]="'..'">
				<mat-icon class="text-primary icon-size-5" svgIcon="heroicons_solid:arrow-narrow-left"></mat-icon>
			</a>

			<span class="text-3xl font-semibold leading-none">
				User management
			</span>
		</div>

		<div class="flex gap-3 items-center border rounded-xl p-4">

			<mat-icon class="icon-size-20" svgIcon="heroicons_solid:user-circle"></mat-icon>

			<div class="flex flex-col gap-2">
				<span class="text-lg font-semibold leading-none">
					{{user?.firstName}} {{user?.lastName}}
				</span>

				<span class="text-secondary leading-none">
					{{user?.email}}
				</span>
				<span class="px-2 py-1 w-fit rounded-full flex uppercase text-xs font-semibold items-center"
					[class]="user?.enabled ? 'bg-green-200 text-green-800' : 'bg-red-100 text-red-800'">
					{{user?.enabled ? 'Active' : 'Inactive'}}
					<mat-icon class="icon-size-4 ml-2" [class]="user?.enabled ? 'text-green-700' : 'text-red-800'"
						[matTooltip]="user?.enabled ? 'This user is active and can access the system.' : 'This user is inactive and cannot access the system.'"
						[svgIcon]="user?.enabled ? 'heroicons_solid:check-circle' : 'heroicons_solid:x-circle'">
					</mat-icon>
				</span>
			</div>

		</div>


	</div>

	<div class="flex flex-col gap-8 max-w-5xl p-6">


		<!-- Site Access -->
		<div class="flex flex-col gap-4">

			<div class="flex gap-4 items-center">
				<div class="flex items-center justify-center bg-primary-200 p-2 rounded-full">
					<mat-icon class="text-primary" svgIcon="heroicons_outline:location-marker"></mat-icon>
				</div>

				<div class="flex flex-col gap-2">
					<span class=" text-xl font-semibold leading-none">
						Site access
					</span>

					<span class="italic text-secondary">
						Select to which sites the user has access
					</span>
				</div>
			</div>

			<div class="grid grid-cols-4 gap-4">
				<div *ngFor="let group of brGroups"
					class="p-4 flex flex-col gap-2 items-center justify-between border rounded-lg bg-card">

					<div class="flex items-center justify-between w-full">

						<span class="font-medium">
							{{group.name | titlecase}}
						</span>

						<mat-slide-toggle [checked]="hasGroup(group.id)" [disabled]="isGroupProcessing(group.id)"
							(change)="changeGroupState(user.id, group.id, $event.checked)" color="primary">
						</mat-slide-toggle>
					</div>
				</div>
			</div>
		</div>

		<mat-divider></mat-divider>

		<!-- Exploration Roles -->
		<div *ngIf="hasGroup(explorationGroupId)" class="flex flex-col gap-4">

			<div class="flex flex-col gap-2">
				<span class=" text-xl font-semibold leading-none">
					Exploration Access
				</span>

				<span class="italic text-secondary">
					Limits the user type on exploration module
				</span>

			</div>

			<div class="grid grid-cols-4 gap-4">
				<div class="p-4 flex items-center justify-between border rounded-lg bg-card">
					<div class="flex flex-col">
						<span class="font-medium">
							Geologist
						</span>
					</div>

					<mat-slide-toggle [checked]="hasGroup(geologistGroupId)" [disabled]="isGroupProcessing(geologistGroupId)"
						(change)="changeRoleState(user.id, geologistGroupId, $event.checked)" color="primary">
					</mat-slide-toggle>
				</div>

				<div class="p-4 flex items-center justify-between border rounded-lg bg-card">
					<div class="flex flex-col">
						<span class="font-medium">
							Assistant
						</span>
					</div>

					<mat-slide-toggle [checked]="hasGroup(assistantGroupId)" [disabled]="isGroupProcessing(assistantGroupId)"
						(change)="changeRoleState(user.id, assistantGroupId, $event.checked)" color="primary">
					</mat-slide-toggle>
				</div>
			</div>
		</div>

		<mat-divider></mat-divider>

		<!-- Access Groups -->
		<div class="flex flex-col gap-4">

			<div class="flex gap-4 items-center">
				<div class="flex items-center justify-center bg-primary-200 p-2 rounded-full">
					<mat-icon class="text-primary" svgIcon="heroicons_outline:view-grid"></mat-icon>
				</div>

				<div class="flex flex-col gap-2">

					<span class=" text-xl font-semibold leading-none">
						Module groups
					</span>

					<span class="italic text-secondary">
						Limits which modules the user can access
					</span>
				</div>
			</div>

			<div class="grid grid-cols-4 gap-4">
				<div *ngFor="let group of moduleGroups"
					class="p-4 flex flex-col gap-2 items-center justify-between border rounded-lg bg-card grow-0">

					<div class="flex items-center justify-between w-full">

						<span class="font-medium">
							{{moduleMap[group.name] ? moduleMap[group.name] : (group.name | titlecase)}}
						</span>

						<div class="flex gap-2 items-center">

							<!-- <button *ngIf="group.subGroups.length" mat-icon-button
								(click)="group.expanded = !group.expanded">
								<mat-icon class="icon-size-5 text-gray-400"
									[svgIcon]="'heroicons_solid:chevron-down'"></mat-icon>
							</button> -->

							<mat-slide-toggle [checked]="hasGroup(group.id)" [disabled]="isGroupProcessing(group.id)"
								(change)="changeGroupState(user.id, group.id, $event.checked)" color="primary">
							</mat-slide-toggle>
						</div>
					</div>

				</div>
			</div>
		</div>

		<mat-divider></mat-divider>

		<!-- Access Roles -->
		<div *ngIf="false" class="flex flex-col gap-4">

			<div class="flex flex-col gap-2">
				<span class=" text-xl font-semibold leading-none">
					Access Roles
				</span>

				<span class="italic text-secondary">
					Limits what functions the user can use.
				</span>

			</div>

			<div class="grid grid-cols-4 gap-4">
				<div *ngFor="let role of allRoles"
					class="p-4 flex items-center justify-between border rounded-lg bg-card">

					<div class="flex flex-col">
						<span class="font-medium">
							{{role.name}}
						</span>

						<span class="text-sm text-gray-600">
							{{role.description}}
						</span>
					</div>

					<mat-slide-toggle [checked]="hasRole(role.name)" [disabled]="isRoleProcessing(role.name)"
						(change)="changeRoleState(user.id, role.name, $event.checked)" color="primary">
					</mat-slide-toggle>
				</div>
			</div>
		</div>

	</div>

</div>
